import React from 'react';

import BillSampleImage from '../../assets/images/BillSample.png';
import { DialogImage } from '../shared';

function SampleBillImage() {
  return (
    <DialogImage
      alt="Alliant Energy account number location on bill"
      width="100%"
      src={BillSampleImage}
      loading="lazy"
    />
  );
}

export { SampleBillImage };
